import Vue from 'vue'
import App from './App'
import Axios from '../../utils/diyaxios'
import router from '../../router/router'
import store from '../../store'
import filters from '../../utils/filters'
import components from '../../utils/components'



import 'assets/google/google-icon.css'


import MuseUI from 'muse-ui'
Vue.use(MuseUI)
import 'muse-ui/dist/muse-ui.css'


// 云闪付插件配置 2021.07.30 备注  需要在打包环境（node_modules）下添加插件文件 vue-cup-ui
import VueCupUi from 'vue-cup-ui'
import 'vue-cup-ui/lib/vue-cup-ui.css'
Vue.use(VueCupUi);


import 'assets/theme.less'
import 'assets/common.less'
import qs from 'qs';



import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)



Vue.prototype.$http = Axios // 类似于vue-resource的调用方法，之后可以在实例里直接用this.$http.get()等


Vue.prototype.URLSearchParam = function () {
    this.SearchParamName = [];
    this.SearchParamValue = [];
    this.append = function (paramName, paramValue) {
        this.SearchParamName.push(paramName);
        this.SearchParamValue.push(paramValue);
    };
    this.toParam = function () {
        if (this.SearchParamName.length == 0)
            return '';
        /*var rel = '';
        rel += '{';
        for (var i = 0; i < this.SearchParamName.length; i++) {
            if (rel != "{")
                rel += ",";
            rel += '"' + this.SearchParamName[i] + '":"' + this.SearchParamValue[i] + '"';
        }
        rel += '}'*/
        var rel = {};
        for (var i = 0; i < this.SearchParamName.length; i++) {
            rel[this.SearchParamName[i]] = this.SearchParamValue[i]
        }

        rel = JSON.stringify(rel);
        //rel = rel.substring(1, rel.length - 1);
        //var re = new RegExp("\\\\", "g");
        //rel = rel.replace(re, "");
        return qs.stringify(JSON.parse(rel));
    }
}



//全局过滤器
filters.setFilter(Vue);
//全局组件
components.setComponents(Vue);
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
})
    //Vue.filter('detailDate',filters.filters.detailDate);


// WEBPACK FOOTER //
// ./src/pages/index/main.js